const returnText = `
    <div class="accordion__content fs-body-100 rte non-page-rte measure" aria-hidden="false" id="accordion-content-accordion-1" data-default-expanded="false" data-measured="true" style="display: block;">
      <p>This item qualifies for the following Return Policy:</p>
        <ul>
          <li>Free return shipping on one Sample Swatch or 2'x4' area rug when 5x8 or larger is ordered.</li>
          <li>30 day return period. </li>
          <li>No Restocking Fees. Customer pays only for return shipping costs. </li>
          <li>Discounted UPS/Fedex return shipping labels available. (<a href="https://incrediblerugsanddecor.com/pages/contact-us" target="_blank">Contact us</a> for pricing.)</li>
        </ul>
        <p>See our full&nbsp;<a href="https://incrediblerugsanddecor.com/pages/policies" target="_blank">store policies</a>&nbsp;page for full return policy details.</p>
        <p>To return an item, visit our <a href="https://incrediblerugsanddecor.com/pages/returns" target="_blank">returns page</a>.</p>
    </div>
`;

const cannotReturnText = `
    <div class="accordion__content fs-body-100 rte non-page-rte measure" aria-hidden="false" id="accordion-content-accordion-1" data-default-expanded="false" data-measured="true" style="display: block;">
      <p>Custom Rugs are not eligible for returns.</p>
    </div>
`;

function initializeReturnInfo(){
  function getCurrentProducts(){
    try {
      let initialProduct = document.querySelectorAll('[id*="variantchange_productData_"]');
      const productLength = initialProduct.length;
      if(initialProduct.length > 0){
        return JSON.parse(initialProduct[0].innerText.trim());
      } return null;
    }catch(err){
      console.error(err);
      return null;
    };
  };
  function getAllReturnDivs(){
    let returnTextDivs = document.querySelectorAll('[id*="returnText"]');
    if(returnTextDivs.length > 0){
      return returnTextDivs;
    } else return null;
  };
  function setReturnData(){
    const products = getCurrentProducts();
    let returnDivs = getAllReturnDivs();
    if(products !== null && returnDivs !== null){
      const divsLength = returnDivs.length;
      for(let it = 0; it < divsLength; it++) {
          returnDivs[it].innerHTML = '';
          let tempElement = document.createElement("div");
          if(products.tags.includes('Group-Cut and Sew') || products.tags.includes('Made To Order') && (!products.vendor.includes('Dalyn') && !products.vendor.includes('Piper Loom'))) 
            tempElement.innerHTML = cannotReturnText.trim();
          else tempElement.innerHTML = returnText.trim();
          returnDivs[it].appendChild(tempElement);
      };
    };
  };
  setReturnData();
};

function initializeProductTextFilters(){
  const attributes = `button#displayedProductOptions, h1#displayedProductOptions, h2#displayedProductOptions, h3#displayedProductOptions, p#displayedProductOptions`;
  const normalizeTextDisplayed = (data) => { return data.toLowerCase().split(" ").map((char) => char.charAt(0).toUpperCase() + char.substring(1)).join(" ") };
  document.addEventListener("DOMContentLoaded", function () {
      document.querySelectorAll(attributes).forEach(element => {
      let textContent = element.textContent.trim();
      let normalizedText = normalizeTextDisplayed(textContent);
      element.textContent = normalizedText;
    });
  });
};

initializeReturnInfo();
initializeProductTextFilters();